import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight } from '../../assets/icons';
import './WarningBar.scss';

const WarningBar = (props) => {
  return (
    <div className='warning-bar' onClick={props.action}>
      <span className='warning-bar__error'>{'Finish setting up your account to begin investing with Realbricks'}</span>{' '}
      {!!props.detailMsg && <span className='warning-bar__detail'>{props.detailMsg}</span>}{' '}
      <ArrowRight color='#dd0d33' size={20} verticalAlign='-4px' />
    </div>
  );
};

WarningBar.propTypes = {
  action: PropTypes.func,
  detailMsg: PropTypes.string,
};

export default WarningBar;
